import { render, staticRenderFns } from "./FollowersWidget.vue?vue&type=template&id=f43bfe80&scoped=true&"
import script from "./FollowersWidget.vue?vue&type=script&lang=js&"
export * from "./FollowersWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f43bfe80",
  null
  
)

export default component.exports